export default __webpack_public_path__ + "static/media/Scope-4.75bd1b4f.png";